import type { TOrderInvoiceBlockReason } from '@team-milva/lab-utils/orderInvoiceBlocking'
import { t } from '@/locales'

/**
 * Translated label for a single invoice-block reason — shared between the order status chip
 * (`Order.ts`'s `getStatusChip()`) and the BC invoice status chip (`getBcInvoiceStatusChip()`),
 * so the "why is this blocked" copy only exists in one place.
 */
export function getOrderInvoiceBlockReasonLabel(reason: TOrderInvoiceBlockReason): string {
  switch (reason) {
    case 'missing-insurance-number':
      return t('W: Mangler skadesnummer')
    case 'missing-final-invoice-payer':
      return t('W: Mangler valg af betaler')
    case 'missing-customer-bc-number':
      return t('W: Kunden mangler BC-kundenummer')
    case 'missing-partner-bc-number':
      return t('W: Forsikringskunden mangler BC-kundenummer')
    case 'missing-prices':
      return t('W: Mangler priser')
    case 'non-positive-quantity':
      return t('W: Antal skal være over 0')
    case 'negative-unit-price':
      return t('W: Negativ stykpris')
    case 'non-positive-total':
      return t('W: Ordretotal er 0 eller negativ')
    case 'missing-currency':
      return t('W: Mangler valuta')
    case 'empty-billing-section':
      return t('W: En faktura er tom')
    case 'deliveries-not-complete':
      return t('W: Ikke alle leveringer er sendt endnu')
  }
}

/**
 * Label for a chip that can only show one reason at a time — shows the first outstanding
 * reason only (by the precedence order `getOrderInvoiceBlockReasons` returns them in). Once
 * that reason is resolved, the next one takes its place on the next render.
 */
export function getOrderInvoiceBlockReasonsLabel(reasons: TOrderInvoiceBlockReason[]): string {
  const [firstReason] = reasons
  return firstReason ? getOrderInvoiceBlockReasonLabel(firstReason) : ''
}
